module.exports = __webpack_public_path__ + "img/logos.a35ecf14.svg";